module.exports = __webpack_public_path__ + "static/media/art.8bda8c52.png";